import { Box, Container } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next'
import SocialLink from './SocialLink';
import { useNavigate } from 'react-router-dom';
import GetCookie from '../Services/GetCookie';
import Data from "../Data/.json"
import DataService from "../Data/Services.json"



function Footer() {
    const { t, i18n } = useTranslation();

    const navigate = useNavigate()

    const cookieMode = GetCookie(Data.mode);
    const handleCloseNavMenu = (link: string) => {
        navigate(link)
    };
    return (
        <footer style={{ padding: "2%" }}>
            <Container>

                <Box sx={{ display: { xs: 'block', md: 'flex' } }}>

                    <Box gap={10} sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box textAlign={"justify"} sx={{ width: { xs: '100%', md: '25%' } }}>
                            <h2>{t("contenu.texte1")}</h2>
                            <label style={{ fontWeight: "lighter" }} htmlFor="">
                                {t("contenu.texte14")}
                            </label>
                        </Box>
                        <Box>
                            <h2>{t("contenu.texte23")}</h2>
                            <Box>
                                {DataService.map((DS) => (
                                    <label
                                        style={{ fontWeight: "lighter", color: cookieMode === "dark" ? "white" : cookieMode === "light" ? "#293038" : "#0cc0df" }}
                                        onClick={() => { handleCloseNavMenu("/services") }}
                                    >
                                        {DS.title.split('|')[i18n.language.toLowerCase() === 'fr'? 0: 1]}
                                        <br /><br />
                                    </label>
                                ))}
                            </Box>
                        </Box>
                        <Box>
                            <h2>{t("contenu.texte24")}</h2>
                            <Box>
                                <label style={{ fontWeight: "lighter", color: cookieMode === "dark" ? "white" : cookieMode === "light" ? "#293038" : "#0cc0df" }}>{t("contenu.texte18")}</label><br /><br />
                                <label style={{ fontWeight: "lighter", color: cookieMode === "dark" ? "white" : cookieMode === "light" ? "#293038" : "#0cc0df" }}>{t("contenu.texte19")}</label><br /><br />
                                <label style={{ fontWeight: "lighter", color: cookieMode === "dark" ? "white" : cookieMode === "light" ? "#293038" : "#0cc0df" }}>{t("contenu.texte20")}</label><br /><br />
                                <label style={{ fontWeight: "lighter", color: cookieMode === "dark" ? "white" : cookieMode === "light" ? "#293038" : "#0cc0df" }}>{t("contenu.texte21")}</label><br /><br />
                            </Box>
                        </Box>
                    </Box>

                    <Box>
                        <h2>{t("contenu.texte22")}</h2>
                        <SocialLink />
                    </Box>
                </Box>
                <hr style={{ opacity: ".5" }} />


                <center>
                    {/* @2023 {t('nom')+" "+t("prenom")+". "+t("copyright")+"."} */}
                    {t("contenu.texte25")} <a style={{outline: "none", textDecoration: "none"}} target='_blank' rel="noreferrer" href={t("lienPartenaire")}>{t("nomPartenaire")}</a>
                    {/* Build By IBG-Alpha Technologie */}

                </center>

            </Container>
        </footer>
    )
}

export default Footer
